<template>
  <div class="conent">
    <div class="xiaolian">
      <span class="iconfont icon-xiaolian"></span>
    </div>
    <div class="t3-explain">
      功能开发中，敬请期待
    </div>
    <div class="goback">
      <span @click="goBack">返回上一级</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "T3Trip",
  data: function() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
.conent {
  width: 100%;
}
.xiaolian {
  width: 6.4rem;
  text-align: center;
  margin: 0 auto;
  margin-top: 50%;
}
.icon-xiaolian {
  font-size: 1.6rem;
  color: #f33c2b;
}
.t3-explain {
  width: 6.4rem;
  text-align: center;
  font-size: 0.4rem;
  margin: 0 auto;
}
.goback {
  width: 6.4rem;
  text-align: center;
  font-size: 0.4rem;
  margin: 0.5rem auto 0 auto;
  color: #00aaea;
}
</style>
